import React, { useRef } from 'react'
import * as THREE from 'three'
import { useFrame } from '@react-three/fiber'

const Floor = () =>{

    const ref = useRef()

  useFrame((state,delta) => {
    ref.current.rotation.y += 0.01
  })

  const material = new THREE.MeshPhysicalMaterial({
    color: '#FE76FF',
    metalness: 0.1,
    roughness: 0,
    transmission: 0.1,
    transparent: true,
    opacity: 0.95,
    clearcoat: 1,
    clearcoatRoughness: 0.5,
    envMapIntensity: 1,
    side: THREE.DoubleSide,
  })

    return <mesh ref={ref} material={material} scale={[4,-0.4,4]} receiveShadow position={[0,0.65,0]}>
        <sphereGeometry />
    </mesh>
}

export default Floor